const INITIATIVES_GROUP_COLUMNS = [
  { field: "expandable", width: 40 },
  {
    title: "Ambassador",
    field: "firstName",
    dataType: "string",
    rendererType: "AMBASSADOR",
  },
  {
    title: "Email",
    field: "email",
    dataType: "string",
  },
  {
    title: "Company",
    field: "company",
    dataType: "string",
  },
  {
    title: "Initiatives",
    field: "projectCount",
    dataType: "number",
    rendererType: "PROJECT_COUNT",
  },
];

const INITIATIVE_PROJECT_COLUMNS = [
  { title: "Title", field: "title", dataType: "string" },
  { title: "Type", field: "type", dataType: "string", rendererType: "TYPE" },
  {
    title: "Status",
    field: "isActive",
    dataType: "boolean",
    rendererType: "ACTIVE",
  },
  {
    title: "Visibility",
    field: "isPublic",
    dataType: "boolean",
    rendererType: "VISIBILITY",
  },
  {
    title: "Planned delivery",
    field: "plannedDeliveryDate",
    dataType: "string",
    rendererType: "PLANNED_DELIVERY",
  },
  {
    title: "Updated",
    field: "updatedAt",
    dataType: "string",
    rendererType: "UPDATED_AT",
  },
  {
    title: "Action",
    field: "action",
    dataType: "string",
    rendererType: "ACTION",
    align: "center",
  },
];

export { INITIATIVES_GROUP_COLUMNS, INITIATIVE_PROJECT_COLUMNS };
